import { c as _c } from "react/compiler-runtime";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import UserPageIdentityAddStatementsSelect from "./UserPageIdentityAddStatementsSelect";
import UserPageIdentityAddStatementsContact from "./contact/UserPageIdentityAddStatementsContact";
import UserPageIdentityAddStatementsSocialMediaAccount from "./social-media/UserPageIdentityAddStatementsSocialMediaAccount";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityAddStatementsSocialMediaPosts from "./social-media-verification-posts/UserPageIdentityAddStatementsSocialMediaPosts";
import { STATEMENT_ADD_VIEW } from "./UserPageIdentityAddStatements";
import UserPageIdentityAddStatementsNFTAccounts from "./nft-accounts/UserPageIdentityAddStatementsNFTAccounts";
export default function UserPageIdentityAddStatementsViews(t0) {
  const $ = _c(15);
  const {
    profile,
    activeView,
    setActiveView,
    onClose
  } = t0;
  switch (activeView) {
    case STATEMENT_ADD_VIEW.SELECT:
      {
        let t1;
        if ($[0] !== onClose || $[1] !== setActiveView) {
          t1 = <UserPageIdentityAddStatementsSelect onClose={onClose} onViewChange={setActiveView} />;
          $[0] = onClose;
          $[1] = setActiveView;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case STATEMENT_ADD_VIEW.SOCIAL_MEDIA_ACCOUNT:
      {
        let t1;
        if ($[3] !== onClose || $[4] !== profile) {
          t1 = <UserPageIdentityAddStatementsSocialMediaAccount profile={profile} onClose={onClose} />;
          $[3] = onClose;
          $[4] = profile;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case STATEMENT_ADD_VIEW.NFT_ACCOUNT:
      {
        let t1;
        if ($[6] !== onClose || $[7] !== profile) {
          t1 = <UserPageIdentityAddStatementsNFTAccounts onClose={onClose} profile={profile} />;
          $[6] = onClose;
          $[7] = profile;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case STATEMENT_ADD_VIEW.CONTACT:
      {
        let t1;
        if ($[9] !== onClose || $[10] !== profile) {
          t1 = <UserPageIdentityAddStatementsContact profile={profile} onClose={onClose} />;
          $[9] = onClose;
          $[10] = profile;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case STATEMENT_ADD_VIEW.SOCIAL_MEDIA_VERIFICATION_POST:
      {
        let t1;
        if ($[12] !== onClose || $[13] !== profile) {
          t1 = <UserPageIdentityAddStatementsSocialMediaPosts profile={profile} onClose={onClose} />;
          $[12] = onClose;
          $[13] = profile;
          $[14] = t1;
        } else {
          t1 = $[14];
        }
        return t1;
      }
    default:
      {
        assertUnreachable(activeView);
      }
  }
}